import { createReducerContext } from '../../../../utils/create-reducer-context';
import { PublicAccountSearchState, PublicAccountSearchReducer, ACTION_TYPES } from './public-account-search-reducer';

const initialState: PublicAccountSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    categories: [],
    documentTypes: [],
    drawer: { open: false, files: [] },
};

const { Provider: PublicAccountSearchProvider, useStateContext: usePublicAccountSearchState, useDispatchContext: usePublicAccountSearchDispatch } = createReducerContext('PublicAccountSearch', PublicAccountSearchReducer, initialState);

export { PublicAccountSearchProvider, usePublicAccountSearchState, usePublicAccountSearchDispatch, ACTION_TYPES };
